import React, {useState, useRef, useEffect} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import { ResponsiveLine } from '@nivo/line'
import { CircleButton } from '../../JurosCompostos/CircleButton';
import Table from './table.svg';
import formatCurrency from '../../../utils'

var moment = require('moment');

export const AdvancedChart = (props) => {

    const [tooltipData, setTooltipData] = useState(null)
    const [showTooltipData, setShowTooltipData] = useState(false)
    const refChart = useRef(null)
    const refTooltip = useRef(null)
    const [isMouseHold, setIsMouseHold] = useState(false)
    const [mousePosition, setMousePosition] = useState({x: 0, y: 0})
    const [chartData, setChartData] = useState([])
    const [chartDataControler, setChartDataControler] = useState([])
    const [updateChartData, setUpdateChartData] = useState(false)

    useEffect(() => {
        if(chartData.length === 0){
            setChartData(props.data)
            let chartDataControler = []
            for (let index = 0; index < props.data[0].data.length; index++) {
                if(props.data[0].data[index] === props.data[0].data[0]){
                    chartDataControler.push({isChanged: false})
                } else {
                    chartDataControler.push({isChanged: true})
                }
            }
            setChartDataControler(chartDataControler)
        } else if(updateChartData){
            props.onChange(chartData)
            setUpdateChartData(false)
        }
        if(showTooltipData){
            let basePositionX = 37.5
            let basePositionY = 70.5
            if(window.screen.width <= 768){
                basePositionX = 37.5
                basePositionY = 72.5
            }
            if((tooltipData.x+basePositionX > (refChart.current.offsetWidth/2))){
                refTooltip.current.className = style.tooltipRight
                refTooltip.current.style.transform = `translate(${tooltipData.x-(refTooltip.current.offsetWidth-(basePositionX-14.5))}px, ${tooltipData.y - basePositionY}px)`
            } else {
                refTooltip.current.className = style.tooltipLeft
                refTooltip.current.style.transform = `translate(${tooltipData.x+basePositionX}px, ${tooltipData.y - (basePositionY)}px)`
            }
        }
    }, [tooltipData, chartData, chartDataControler])

    // Update data by mouse move
    function updateData(mouseMoveValue, dataPosition, isAutomatic=false){
        console.log("updateData -----------------")
        console.log(250*(88/100))
        if(dataPosition > 0){
            let chartControler = chartDataControler
            if(!isAutomatic){
                chartControler[dataPosition].isChanged = true
                setChartDataControler(chartControler)
            }
            let newChartData = Object.assign([], chartData)
            if(mouseMoveValue > 0 && props.maxValue > newChartData[0].data[dataPosition].y){
                newChartData[0].data[dataPosition].y = newChartData[0].data[dataPosition].y + 0.5
                if(newChartData[0].data[dataPosition].y > props.maxValue){
                    newChartData[0].data[dataPosition].y = props.maxValue
                }
            } else if(mouseMoveValue < 0 && props.minValue < newChartData[0].data[dataPosition].y){
                newChartData[0].data[dataPosition].y = newChartData[0].data[dataPosition].y - 0.5
                if(newChartData[0].data[dataPosition].y < props.minValue){
                    newChartData[0].data[dataPosition].y = props.minValue
                }
            }
            setChartData(newChartData)
            if(dataPosition < (newChartData[0].data.length-1)){
                if(chartControler[dataPosition+1].isChanged === false){
                    updateData(mouseMoveValue, dataPosition + 1, true)
                }
            }
            setUpdateChartData(true)
        }
    }

    // Cria escala Y do gráfico
    function scaleY(maxValue){
        let dezena = 10
        let maximo = 0
        let pontosCount = 0
        let pontosGrafico = []
        while(maxValue > dezena){
            dezena = dezena * 10
        }
        if(maxValue === dezena){
            maximo = dezena
        } else {
            dezena = dezena/10
            maximo = dezena * 2
            if(maxValue >= dezena * 5){
                maximo = dezena + (dezena * 5)
            }
            while(maxValue > maximo){
                if(window.screen.width <= 768){
                    maximo += dezena *2
                }else{
                    maximo += dezena *1
                }
                pontosCount++
            }
        }
        let ponto = 0
        while(ponto <= maximo){
            pontosGrafico.push(ponto)
            if(window.screen.width <= 768){
                ponto++
            } else{
                ponto++
            }
            
        }
        return(pontosGrafico)
    }

    function maxChartValue(maxValue){
        let pontoMaximo = scaleY(maxValue)
        if(pontoMaximo.length > 0){
            return pontoMaximo[pontoMaximo.length-1]
        }
        return 0
    }

    function abbreviateNumber(value) {
        var newValue = value;
        if (value >= Math.pow(10,6)) {
            var suffixes = ["", "K", "M", "B","T"];
            var suffixNum = Math.floor( (""+value).length/3 );
            var shortValue = '';
            for (var precision = 3; precision >= 1; precision--) {
                shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000,suffixNum) ) : value).toPrecision(precision));
                var dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g,'');
                if (dotLessShortValue.length <= 3) { break; }
            }
            if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1);
            return shortValue+suffixes[suffixNum];
        }
        return newValue.toLocaleString('pt-BR', {
            currency: 'BRL'
          });
    }

    // Define o estilo das linhas com base no id
    const styleById = {
        default: {
            strokeWidth: 3,
            fontSize: '5px'
        },
    }

    // Cria as linhas e define os estilos de cada uma
    const Lines = ({ series, lineGenerator, xScale, yScale }) => {
        return series.map(({ id, data, color }) => (
            <path
                key={`${id}_line`}
                d={lineGenerator(
                    data.map((d, index) => {
                        return ({
                        key: `${id}_${index}`,
                        x: xScale(d.data.x),
                        y: yScale(d.data.y),
                    })})
                )}
                fill="none"
                stroke={color}
                style={styleById[id] || styleById.default}
            />
        ))
    }

    // Cria os pontos no grafico e define os estilos de cada um
    const Points = ({ series, xScale, yScale }) => {
        let points = []
        points.push(
            <g key="points">
                {series.map(({ id, data, color }, index)=>{
                    return data.map(({data}, indexPoints)=>{
                        return <g key={`${id}_${index}_${indexPoints}_points`} style={{pointerEvents: 'none', transform: `translate(${xScale(data.x)}px, ${yScale(data.y)}px)`, zIndex: 15}}>
                            <circle r={"3"} fill={color} stroke={color} strokeWidth="1" style={{pointerEvents: 'none'}}></circle>
                        </g>
                    })
                })}
            </g>
        )
        return points
    }

    function Slices({series}){
        let slices = []
        for (let index = 0; index < series[0].data.length; index++) {
            let tooltipPosition = {
                x: 0,
                y: 0,
                y2: 0,
                data: []
            }
            if(series[0].data[index].position.x > tooltipPosition.x){
                tooltipPosition.x = series[0].data[index].position.x
            }
            if(series[0].data[index].position.y > tooltipPosition.y){
                tooltipPosition.y = series[0].data[index].position.y
            }
            series.map((serie)=>{
                tooltipPosition.data.push({id: serie.id, x: serie.data[index].data.x, y: serie.data[index].data.y})
            })
            slices.push(<rect key={`slice${index}`} onMouseOver={()=>{
                if(window.screen.width > 768){
                    setTooltipData(tooltipPosition)
                    setShowTooltipData(true)
                }
            }}
            onMouseLeave={()=>{
                setShowTooltipData(false)
                setIsMouseHold(false)
            }}
            onClick={(event)=>{
                setTooltipData(tooltipPosition)
                setShowTooltipData(true)
            }}
            onMouseDown={(e)=>{
                setMousePosition({x: e.pageX, y: e.pageY})
                setIsMouseHold(true)
                setTooltipData(tooltipPosition)
                setShowTooltipData(true)
            }}
            onMouseUp={()=>{
                setIsMouseHold(false)
                setTooltipData(tooltipPosition)
                setShowTooltipData(true)
            }}
            onMouseMove={(e)=>{
                if(isMouseHold){
                    setShowTooltipData(false)
                    if((mousePosition.y - e.pageY) >= 10 || (e.pageY - mousePosition.y) >= 10){
                        setMousePosition({x: e.pageX, y: e.pageY})
                        updateData(mousePosition.y - e.pageY, index)
                        
                    }
                }
            }}
            onTouchEnd={()=>{
                document.body.style.overflow = "auto"
                setIsMouseHold(false)
                setTooltipData(tooltipPosition)
                setShowTooltipData(true)
            }}
            onTouchStart={()=>{
                document.body.style.overflow = "hidden"
                setIsMouseHold(true)
            }}
            onTouchMove={(e)=>{
                if(isMouseHold){
                    document.body.style.overflow = "hidden"
                    setMousePosition({x: e.changedTouches[0].screenX, y: e.changedTouches[0].screenY})
                    updateData((mousePosition.y - e.changedTouches[0].screenY), index)
                    setTooltipData(tooltipPosition)
                    setShowTooltipData(true)
                }
            }}
            x={(window.screen.width <= 768)?tooltipPosition.x-10:tooltipPosition.x-10} y="0" width={(window.screen.width <= 768)?'20':'20'} height="88%" stroke="red" strokeWidth="0" strokeOpacity="0.75" fill="red" fillOpacity="0" style={{position: 'absolute', zIndex: 20}}></rect>)
        }
        return slices
    }

    // Retorna o tooltip customizado
    function tooltip(){
        let elements = []
        elements.push(<div className={style.tooltipTitle}>{tooltipData.data[0].x}</div>)
        for (let index = 0; index < tooltipData.data.length; index++) {
            elements.push(
            <div
                key={tooltipData.data[index].id}
                className={style.tooltipText}
            >
                <strong>
                    {formatCurrency(tooltipData.data[index].y)}%
                </strong>
            </div>
            ) 
        }
        let elementReturn = []
        elementReturn.push(<div ref={refTooltip} className={style.tooltip, style.tooltipCircle} style={{position: 'absolute', padding: '12px', zIndex: 10, display: 'none'}}>{elements}</div>)
        return elementReturn
    }

    return (
        <div className={style.main}>
            <div className={style.chartDiv}>
                <div className={style.chart} ref={refChart}>
                    {(showTooltipData)?tooltip():null}
                    <ResponsiveLine
                        curve="monotoneX"
                        data={chartData}
                        margin={(window.screen.width <= 768)?{ top: 10, right: 10, bottom: 50, left: 30 }:{ top: 10, right: 20, bottom: 20, left: 30 }}
                        gridYValues={scaleY(props.maxValue)}
                        yScale={{ type: 'linear', min: props.minValue, max: maxChartValue(props.maxValue), stacked: false, reverse: false }}
                        axisTop={null}
                        axisRight={null}
                        axisBottom={{
                            tickRotation:(window.screen.width <= 768)?-75:0,
                            format: (values) => (parseInt(values)>0)?values:moment(values).format('MMM YY')
                        }}
                        axisLeft={{
                            orient: 'left',
                            format: (values) => {
                                if((values % 2) === 0){
                                    return abbreviateNumber(parseFloat(values))+'%'
                                } else{
                                    return ''
                                }
                            },
                            tickSize: 0,
                            tickValues: scaleY(props.maxValue)
                        }}
                        theme={{
                            fontFamily: 'Montserrat',
                            fontSize: '10px',
                            textColor: '#98B2D1',
                            axis: {
                            ticks: {line: {strokeWidth: 0}}
                            }, 
                            grid: {line: {stroke: '#98B2D1'}}
                        }}
                        colors={['#4B6584', '#4B6584']}
                        enablePoints={false}
                        useMesh={true}
                        enableSlices='x'
                        layers={['grid', 'markers', 'areas', Lines, Slices, Points, 'axes', 'legends']}
                    />
                </div>
            </div>
        </div>
    )
}